import React, {useState} from 'react';
import {Tabs, Typography} from 'antd';
import {useLocation} from 'react-router-dom';
import useTitle from '@/hook/useTitle';
import reportRoutes from './reportRoutes';
import {PieChartOutlined} from '@/icons';

import styles from './index.module.less';

export default function ReportPage() {
    useTitle('数据统计');
    const location = useLocation();
    console.log('report location', location);
    const [activeKey, setActiveKey] = useState(reportRoutes[0].path);

    // useEffect(() => {
    //     const route = reportRoutes.find(({path}) => {
    //         console.log('path', path, location.pathname);
    //         const m = matchPath(path, location.pathname);
    //         console.log('m', m);
    //         return m;
    //     });
    //     if (route) {
    //         setActiveKey(route.path);
    //     }
    // }, [location.pathname]);

    function onTabChange(key) {
        // let toPath = key.replace(':appId', appId);
        setActiveKey(key);
    }

    const tabLeft = (
        <Typography.Text type="secondary" className={styles.tabsTitle}>
            <PieChartOutlined style={{marginRight: 10}} />
            数据统计
        </Typography.Text>
    );
    return (
        <div className={styles.container}>
            <Tabs
                className={styles.tabs}
                onChange={onTabChange}
                activeKey={activeKey}
                tabBarExtraContent={{left: tabLeft}}
            >
                {reportRoutes.map(({path, label, Comp}) => (
                    <Tabs.TabPane key={path} tab={label}>
                        <div className={styles.content}>
                            <Comp />
                        </div>
                    </Tabs.TabPane>
                ))}
            </Tabs>
        </div>
    );
}
